import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import EmptyExperienceFigure from "../../assets/images/empty-experience-figure.png";

import { styles } from "./styles";

export const EmptyExperience = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "experience" });

  return (
    <Box
      sx={{
        ...styles.container,
        rowGap: "16px",
      }}
    >
      <Typography sx={styles.title}>{t("experience")}</Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          rowGap: "16px",
        }}
      >
        <img src={EmptyExperienceFigure} alt="empty-endorsed-skills-figure" width={58.816} height={73.848} />
        <Typography
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "20px",
          }}
        >
          {t("noExperience")}
        </Typography>
      </Box>
    </Box>
  );
};
